import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import AboutPage from "./AboutPage";
import CallenticaPage from "./CallenticaPage";
import CareersPage from "./CareersPage";
import ContactPage from "./ContactPage";
import LandingPage from "./Home";
import ModelPage from "./ModelPage";
import ProjectsPage from "./ProjectsPage";
import RndPage from "./RndPage";
import ServicesPage from "./ServicesPage";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (typeof window !== "undefined" && typeof window.scrollTo === "function") {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }
  }, [pathname]);

  return null;
}

export default function App() {
  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/ourmodel" element={<ModelPage />} />
        <Route path="/our-model" element={<ModelPage />} />
        <Route path="/model" element={<ModelPage />} />
        <Route path="/projects" element={<ProjectsPage />} />
        <Route path="/rnd" element={<RndPage />} />
        <Route path="/careers" element={<CareersPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/callentica" element={<CallenticaPage />} />
      </Routes>
    </Router>
  );
}